import React from "react";
import { BookOpen, Clock, Heart, MessageCircle } from "lucide-react";
import { TspBadge } from "../../../components/primitives";
import { formatDate } from "../../../utils/tspFormat";
import { excerptOf, readMinutes } from "../storyModel";

// A story or blog in the list: cover (uploaded image, else a tinted panel),
// category, title, excerpt, byline and engagement counts. The title is the
// real button that opens the reader.
export default function StoryCard({ story, category, featured = false, onOpen }) {
  return (
    <article className={`tsp-story-card ${featured ? "tsp-story-card-featured" : ""}`}>
      <div className={`tsp-story-cover tsp-story-tone-${story.tone}`}>
        {story.imageUrl ? <img src={story.imageUrl} alt="" /> : <BookOpen size={featured ? 40 : 30} aria-hidden="true" />}
      </div>

      <div className="tsp-story-body">
        <div className="tsp-story-top">
          {category && <TspBadge tone={category.tone}>{category.label}</TspBadge>}
          {featured && <span className="tsp-story-featured-tag">Featured</span>}
        </div>

        <h3 className="tsp-story-title">
          <button type="button" onClick={() => onOpen(story.id)}>
            {story.title}
          </button>
        </h3>
        <p className="tsp-story-excerpt">{excerptOf(story.content, featured ? 260 : 140)}</p>

        <div className="tsp-story-meta">
          <span>
            <strong>{story.author}</strong> · {formatDate(story.createdAt)}
          </span>
          <span className="tsp-story-meta-icons">
            <span title="Reading time">
              <Clock size={13} aria-hidden="true" /> {readMinutes(story.content)} min
            </span>
            <span title="Likes" aria-label={`${story.likes} likes`}>
              <Heart size={13} aria-hidden="true" /> {story.likes}
            </span>
            {/* The list sends only the count (comment_count); comments load when a story is opened. */}
            <span title="Comments" aria-label={`${story.commentCount} comments`}>
              <MessageCircle size={13} aria-hidden="true" /> {story.commentCount}
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}
